import React from 'react';
import Avatar from '../Helpers/Avatar';
import { FormCardGroup, FormRadio } from '../Helpers/Form';
import './User.css';
import Scores from '../Helpers/Storage/Scores.json';
import Storage from '../Helpers/Storage/Storage';

const scoreValues = new Map(Scores);

const Comment = props => {
  const { owner, comment, rating } = props;
  return (
    <div>
      <div>
        <Avatar {...owner} />
        <div>{ owner && owner.displayName }</div>
        <div className="score">
          <FormCardGroup type="card">
            {Array.from(scoreValues)
              .filter(([key]) => key <= rating)
              .map(([key]) => (
                <FormRadio
                  key={key}
                  name="rating"
                  value={key}
                  selectedValue={rating}
                  image={Storage.get('pawprint')}
                />))}
          </FormCardGroup>
        </div>
      </div>
      <div>
        {comment}
      </div>
    </div>);
};

export default Comment;



// WEBPACK FOOTER //
// ./src/pages/User/Comment.js